import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WEEKDAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const

type Props = {
  weekDay: number
  format?: 'long' | 'short'
}

export const useWeekday = () => {
  const { t } = useTranslation()

  return (weekDay: number): string =>
    t(`common.weekDays.${WEEKDAY_KEYS[weekDay - 1]}.long` as 'common.weekDays.monday.long')
}

export const Weekday: FC<Props> = ({ weekDay, format = 'long' }) => {
  const { t } = useTranslation()

  return <>{t(`common.weekDays.${WEEKDAY_KEYS[weekDay - 1]}.${format}` as 'common.weekDays.monday.long')}</>
}
